module.exports = __webpack_public_path__ + "img/official.f256c614.png";